// CSRF token management for frontend
class CSRFService {
    private token: string | null = null;

    async getToken(): Promise<string> {
        if (!this.token) {
            await this.refreshToken();
        }
        return this.token!;
    }

    async refreshToken(): Promise<void> {
        const response = await fetch('/csrf-token', { credentials: 'include' });
        if (!response.ok) {
            throw new Error('Failed to get CSRF token');
        }
        const data = await response.json();
        this.token = data.csrfToken;
    }

    async addCSRFHeaders(headers: Record<string, string> = {}): Promise<Record<string, string>> {
        const token = await this.getToken();
        return {
            ...headers,
            'X-CSRF-Token': token,
        };
    }

    // Force re-fetch on next request (e.g. after session change from auth refresh)
    invalidate(): void {
        this.token = null;
    }

    // Clear tokens on auth changes (logout)
    clearTokens(): void {
        this.token = null;
    }
}

export const csrfService = new CSRFService();
